import React from 'react';

import { Box, Heading } from '@chakra-ui/react';
import AppConfig from 'AppConfig';

export default function NavHeader() {
  return (
    <Box
      height="58px"
      bg="brand.primary"
      color="essentials.white"
      display="flex"
      alignItems="center"
      justifyContent="center">
      <Heading {...AppConfig.logo.navLogoTextStyles}>{AppConfig.name}</Heading>
    </Box>
  );
}
